export const STEP_INITIAL = 'STEP_INITIAL';

export const STEP_CONFIRM = 'STEP_CONFIRM';
